/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReddIdIn
 */
export interface ReddIdIn {
    /**
     * 
     * @type {string}
     * @memberof ReddIdIn
     */
    reddId?: string;
}

export function ReddIdInFromJSON(json: any): ReddIdIn {
    return ReddIdInFromJSONTyped(json, false);
}

export function ReddIdInFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReddIdIn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reddId': !exists(json, 'reddId') ? undefined : json['reddId'],
    };
}

export function ReddIdInToJSON(value?: ReddIdIn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reddId': value.reddId,
    };
}


